export const StyleConstants = {
    headerHeight: 48,
    leftBarWidth: 68,
    leftBarFlyoutWidth: 70,
    leftBarSmallWidth: 50,
    appContentMinWidth: 767, // Ensure that this matches with "ScreenSize.Small" in Responsive.types.ts

    contentBlockPadding: 16,
    headerBackgroundColor: "#2C2C2C",
    appLineHeight: 48,
    opsGenieRightSidePanelWidth: 400,

    /**
     *A CSS selector name applied on Dashboard tiles that should be used by child components to make them draggable.
     */
    dashboardDragSelector: "dashboardDragSelector"
};
